export default "__VITE_ASSET__CMlYUjXt__"